export default (x, y, width, height /*, color*/) =>
  `<?xml version="1.0" encoding="iso-8859-1"?> <svg x="${x}px" y="${y}px" width="${width}px" height="${height}px"  version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
	 viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve">
<path class="st0" d="M14.7,19.5c-2-2-2-5.1,0-7.1l4-4l-0.9-0.9c-2.3-2.3-6.1-2.3-8.5,0l-4.2,4.2c-2.3,2.3-2.3,6.1,0,8.5l4.2,4.2
	c2.3,2.3,6.1,2.3,8.5,0l0.9-0.9L14.7,19.5z"/>
<path class="st0" d="M20.7,20.9l-2.8-2.8c-1.2-1.2-1.2-3.1,0-4.2l2.8-2.8c1.2-1.2,3.1-1.2,4.2,0l2.8,2.8c1.2,1.2,1.2,3.1,0,4.2
	l-2.8,2.8C23.8,22.1,21.9,22.1,20.7,20.9z"/>
</svg>`;
